import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { isEmailValid } from 'common/utility/helpers';

import SrButton from 'client/components/SrButton/SrButton';
import SrErrorMessage from 'client/components/SrErrorMessage/SrErrorMessage';

export const SR_EDIT_TEXTBOX_INPUT_TYPE_TEXT = 'text';
export const SR_EDIT_TEXTBOX_INPUT_TYPE_EMAIL = 'email';

class SrEditTextbox extends Component {
  static propTypes = {
    initialValue: PropTypes.string.isRequired,
    onSave: PropTypes.func.isRequired,
    className: PropTypes.string,
    placeholder: PropTypes.string,
    shouldAllowInputChange: PropTypes.func,
    withSaveButton: PropTypes.bool,
    srButtonProps: PropTypes.object,
    inputType: PropTypes.oneOf([SR_EDIT_TEXTBOX_INPUT_TYPE_TEXT, SR_EDIT_TEXTBOX_INPUT_TYPE_EMAIL]),
  };

  constructor(props) {
    super(props);
    this.state = {
      editValue: props.initialValue,
      errorMessage: '',
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.initialValue !== this.props.initialValue) {
      this.setState({
        editValue: nextProps.initialValue,
      });
    }
  }

  _onInputRef = (el) => {
    this._inputEl = el;
  };

  _onKeyDown = (e) => {
    const { withSaveButton } = this.props;
    const errorMessage = this._getValidator()(this.state.editValue);

    if (e.keyCode === 13 && this._inputEl && !withSaveButton) {
      if (errorMessage) {
        return this.setState({ errorMessage });
      }

      this._inputEl.blur();
      this.setState({
        errorMessage: '',
        editValue: this.props.initialValue,
      });
    }
  };

  _getValidator = () => {
    const { inputType } = this.props;
    if (inputType === SR_EDIT_TEXTBOX_INPUT_TYPE_EMAIL) {
      return (value) => {
        if (!value) {
          return 'Email is required';
        }
        if (!isEmailValid(value)) {
          return 'Invalid email';
        }
        return '';
      };
    }
    return '';
  };

  _onChange = (e) => {
    const { shouldAllowInputChange } = this.props;
    const newValue = e.target.value;

    if (!shouldAllowInputChange || shouldAllowInputChange(newValue)) {
      this.setState({
        editValue: newValue,
        errorMessage: '',
      });
    }
  };

  _onBlur = () => {
    const { initialValue, onSave, withSaveButton } = this.props;
    const { editValue } = this.state;

    if (initialValue !== editValue && !withSaveButton) {
      const errorMessage = this._getValidator()(editValue);

      if (errorMessage) {
        return this.setState({ errorMessage });
      }

      onSave(editValue);
    }
  };

  _onSaveButtonClick = () => {
    const { onSave, initialValue } = this.props;
    const { editValue } = this.state;
    const errorMessage = this._getValidator()(editValue);

    if (errorMessage) {
      return this.setState({ errorMessage });
    }

    onSave(editValue);
    this.setState({
      editValue: initialValue,
      errorMessage: '',
    });
  };

  render() {
    const { placeholder, className, withSaveButton, srButtonProps } = this.props;
    const { editValue, errorMessage } = this.state;

    const ButtonComponent = srButtonProps ? SrButton : 'button';

    return (
      <>
        <input
          type="text"
          ref={this._onInputRef}
          className={className}
          placeholder={placeholder}
          onKeyDown={this._onKeyDown}
          onChange={this._onChange}
          onBlur={this._onBlur}
          value={editValue}
        />
        {errorMessage && <SrErrorMessage>{errorMessage}</SrErrorMessage>}
        {withSaveButton && (
          <ButtonComponent
            type="button"
            onClick={this._onSaveButtonClick}
            disabled={!editValue || !!errorMessage}
            {...srButtonProps}
          >
            {srButtonProps.text || 'Add'}
          </ButtonComponent>
        )}
      </>
    );
  }
}

SrEditTextbox.defaultProps = {
  inputType: SR_EDIT_TEXTBOX_INPUT_TYPE_TEXT,
  withSaveButton: true,
};

SrEditTextbox.displayName = 'SrEditTextbox';

export default SrEditTextbox;
